





























import { Component, Vue, Prop } from 'vue-property-decorator';
import { TenantStats } from '@/views/tenants/TenantClass';

@Component({})
export default class TenantStatsClass extends Vue {
  @Prop({ required: true })
  data!: TenantStats
  
  private headingClasses: string = 'font-semibold uppercase text-xs tracking-wide text-grey';
}
